import axios from "./axios";
import {runInAction} from "mobx";
export function storeGetPost(route, store, data, once=false, actionCall=null, method="get") {
  if(!once || (once && !store.fetching && !store.inited)) {
      store.fetching = true;

      axios.post(route, data).then((data) => {
        runInAction(()=>{
          store.data = data.data.answer;
          if(actionCall) {
            actionCall();
          }
          store.inited = true;
          store.fetching = false;
        });
      });
    }
}

export function storeGet(route, store, once=false, actionCall=null) {
  if(!once || (once && !store.fetching && !store.inited)) {
    store.fetching = true;

    axios.get(route).then((data) => {
      runInAction(()=>{
        store.data = data.data.answer;
        if(actionCall) {
          actionCall();
        }
        store.inited = true;
        store.fetching = false;
      });
    });
  }
}